// Obecná komponenta pro odstranění záznamů v administraci docházky
// parametry: ID záznamu, url příslušného API, tiutulek dotazu, vlasttní dotaz

// příklad volání z nadřazené komponenty:
// <DeleteZaznamu urlAPI="/api/Dochazka/OdstraneniUvazkuZam/" idZaznamu={u.idUvazek} 
// titulek={"Zaměstnanec: " + u.prijmeni + " " + u.jmeno}
// dotaz={"Přejete si odstranit úvazek uvedeného zaměstnance?"}/> 

import { Fragment, useRef, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/solid'
import { useAppContext, SET_INFORMATION_ALERT, SET_ERROR_ALERT, REFRESH_DATA } from '../../../Providers/AppProvider';
import { TrashIcon } from '@heroicons/react/24/solid'
import axios from 'axios';
import { Config } from "../../../Config";

export default function DeleteZaznamu({idZaznamu, urlAPI, titulek, dotaz}) {
  const { dispatch } = useAppContext()
  const [open, setOpen] = useState(false)

  const cancelButtonRef = useRef(null)

  function DeleteRec() {
    axios.post(`${Config.ServerURL}${urlAPI}${idZaznamu}`, undefined, {
      withCredentials: true
    })
      .then((res) => {
        if (res.data.message) {
          dispatch({ type: SET_INFORMATION_ALERT, payload: res.data.message })
        }
        dispatch ({ type: REFRESH_DATA })
        setOpen(false)
      })
      .catch(err => {
        setOpen(false)
        dispatch({ type: SET_ERROR_ALERT, payload: err.response.data.message })
      })
  }

  return (
    <>
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-20" initialFocus={cancelButtonRef} onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="dialog-transition" />
          </Transition.Child>

          <div className="fixed inset-0 z-30 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="dialog-dotaz-ramecek">
                  <div className="dialog-dotaz-obsah">
                    <div className="sm:flex sm:items-start">
                      <div className="dialog-dotaz-ikona-pozadi-cervenykruh">
                        <ExclamationTriangleIcon className="dialog-dotaz-ikona-cervena" aria-hidden="true" />
                      </div>
                      <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">

                        {/* Titulek dotazu */}
                        <Dialog.Title as="h3" className="dialog-dotaz-nadpis-cerveny">
                          {titulek}
                        </Dialog.Title>

                        {/* Text dotazu */}
                        <div className="mt-2">
                          <p className="dialog-dotaz-otazka">
                            {dotaz}
                          </p>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div className="dialog-dotaz-zapati-pozadi">
                    <button type="button" className="dialog-tlacitko-dotaz-akce"
                      onClick={() => DeleteRec()}>Odstranit</button>
                    {/* Tlačítko zavřít */}
                    <button
                      type="button"
                      className="dialog-tlacitko-dotaz-zrusit"
                      onClick={() => setOpen(false)}
                      ref={cancelButtonRef}
                    >
                      Zpět bez odstranění
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      <div onClick={() => setOpen(true)} className="dialog-edit-ikona-odstraneni">
        <span className="sr-only">Odstranit</span>
        <TrashIcon className='ikonka-velikostS' aria-hidden="true" />
      </div>
    </>
  )
}
